import { render } from "./shops_list_block.vue?vue&type=template&id=1c3a1313&scoped=true"
import script from "./shops_list_block.vue?vue&type=script&lang=js"
export * from "./shops_list_block.vue?vue&type=script&lang=js"

import "./shops_list_block.vue?vue&type=style&index=0&id=1c3a1313&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3a1313"]])

export default __exports__